import { c as x, r as E, n as I, i as p, a as m, e as b, t as d, S as C, f as i, F as N } from "./__packages__deps__web-929faed1.js";
import { c as $ } from "./__packages__deps__store-ec58bf2c.js";
const j = /* @__PURE__ */ d('<div class="App tw-flex tw-justify-end"><div class="tw-flex tw-items-center tw-gap-4"><ul class="tw-flex tw-gap-2"></ul><a class=""></a></div></div>'), T = /* @__PURE__ */ d('<li class="tw-flex tw-h-[60px] tw-w-[50px] tw-items-center tw-justify-center tw-border"></li>'), F = /* @__PURE__ */ d('<li class="tw-relative tw-h-[60px] tw-w-[50px] tw-cursor-pointer tw-border [&amp;:hover>span]:tw-flex [&amp;>span]:tw-hidden"><span class="tw-absolute tw-inset-0 tw-items-center tw-justify-center tw-bg-black/50 tw-text-lg tw-font-bold tw-text-white"><span>X</span></span><img class="tw-h-full tw-w-full"></li>'), J = (t, s) => {
  const e = sessionStorage.getItem(t), [r, l] = $(e ? JSON.parse(e) : s);
  return x(() => sessionStorage.setItem(t, JSON.stringify(r))), [r, l];
}, S = (t, s) => {
  t.checked = !!s.find((e) => e.handle === t.getAttribute("data-id"));
}, _ = () => document.querySelectorAll('[data-button-type="compare-product-button"]'), [a, A] = J("products", []), [w, L] = $([..._()]);
window.comparator.refreshInputs = () => L([..._()]);
window.addEventListener("load", () => {
  w.forEach((t) => {
    S(t, a);
  });
});
x(() => {
  w.forEach((t) => {
    S(t, a), t.onchange = () => {
      const s = t.getAttribute("data-id"), e = t.getAttribute("data-image");
      A(t.checked ? [...a, {
        handle: s,
        image: e
      }] : a.filter((r) => r.handle !== s));
    }, t.disabled = a.length >= 3 && !a.find((s) => s.handle === t.getAttribute("data-id"));
  });
});
const O = () => {
  const t = (e) => {
    A(a.filter((r) => r.handle !== e)), w.forEach((r) => {
      r.getAttribute("data-id") === e && (r.checked = !1);
    });
  }, s = () => [...a, ...Array.from(Array(3 - a.length).fill(null))];
  return (() => {
    const e = j.cloneNode(!0), r = e.firstChild, l = r.firstChild, f = l.nextSibling;
    return p(l, m(N, {
      get each() {
        return s();
      },
      children: (k) => m(C, {
        keyed: !0,
        when: k,
        get fallback() {
          return T.cloneNode(!0);
        },
        children: (c) => (() => {
          const o = F.cloneNode(!0), y = o.firstChild, h = y.nextSibling;
          return o.$$click = () => t(c.handle), b((n) => {
            const u = c.image, g = c.handle;
            return u !== n._v$ && i(h, "src", n._v$ = u), g !== n._v$2 && i(h, "alt", n._v$2 = g), n;
          }, {
            _v$: void 0,
            _v$2: void 0
          }), o;
        })()
      })
    })), p(f, () => a.length >= 2 ? window.comparator.redirectToText : window.comparator.informativeText), b(() => i(f, "href", a.length >= 2 ? "/pages/compare" : "#")), e;
  })();
}, v = document.getElementById("comparator");
v && E(O, v);
I(["click"]);
